import React,{useState,useEffect,useRef} from 'react';
import {currentDateFormat} from "../utils";
import { Base64 } from 'js-base64';
import { useLocation } from 'react-router-dom';
import {capitalizeFirstLetter} from "../utils";
import Table from 'react-bootstrap/Table';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../redux/loaderAction';
import Loader from '../components/loader/Loader';
import axios from 'axios';
import {GET_CHECKLIST_REPORT,GET_CHECK_LIST } from '../constant'; 
import { faFilePdf,faSpinner } from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import { dateFormat } from "../utils";
import html2canvas from 'html2canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VehiclePDF from '../components/pdfContent/VehiclePDF';

function VehicleReport() {
     const dispatch = useDispatch();
     const pdfRef = useRef();
      const loading = useSelector((state) => state.loader.loading);
    const [currentDate,setCurrentDate] = useState(new Date());
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedVehicleName = queryParams.get('vehicleName');
    const encodedVehicleId = queryParams.get('vehicleId');
    const vehicleName = Base64.decode(encodedVehicleName);
    const vehicleId = Base64.decode(encodedVehicleId);
    const [checkListReport,setCheckListReport] = useState();
    const [loadingRow, setLoadingRow] = useState(null);
     const [pdfDetails, setPdfDetails] = useState(null);
     const [checkList, setCheckList] = useState();
     const [questionList, setQuestionList] = useState([]);


useEffect(()=>{
    dispatch(setLoading(true));
    const loadUser = async () => {
        try {
          const checkListResponse = await axios.get(GET_CHECK_LIST);
          setCheckList(checkListResponse.data)
          const response = await axios.post(GET_CHECKLIST_REPORT, {
            vehicleName,
            vehicleId
          });
          console.log("setCheckListReport",response.data);
          if (response.data.status === "200") {
            dispatch(setLoading(false));
            setCheckListReport(response.data.data.result);
            setQuestionList(response.data.data.questionsList);
            //console.log(response.data.data);
            // Handle the response data as needed
          }
        } catch (error) {
          console.error("Error fetching checklist report:", error);
          dispatch(setLoading(false));
        }
      };
    loadUser();
},[vehicleName,vehicleId]);

const generatePDF = (details,index) => {
    setLoadingRow(index); 
    setPdfDetails(details);
      //const input = document.getElementById('pdf');
      //if (pdfRef.current) {
        setTimeout(() => {
        var input = pdfRef.current;
        if (input) {
      html2canvas( input,{ useCORS: true, allowTaint: true }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm
        const padding = 10; // Padding in mm
      const contentWidth = imgWidth - padding * 2; // Content width with padding
      const imgHeight = (canvas.height * contentWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
  
      pdf.addImage(imgData, 'PNG', padding, position, contentWidth, imgHeight);
      heightLeft -= pageHeight;
  
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', padding, position, contentWidth, imgHeight);
        heightLeft -= pageHeight;
      }
        pdf.save(`Vehicle_Checklist_${vehicleId}.pdf`);
        setLoadingRow(null);
      });
    }else {
          console.error("pdfRef.current is null or undefined");
          setLoadingRow(null);
   }
  }, 1000);
    };

    return(
        <div className="tab-pane fade active show" id="add-driver" role="tabpanel" aria-labelledby="driver-tab">
            <div className="container-fluid px-mobile-2">
    
                <section>
                    
                 <div className='d-flex justify-content-between form-container'>
                    <div>
                        <h2 className="fs-5 font-weight-600">{` ${capitalizeFirstLetter(vehicleName)} - Checklist Report`}</h2>
                    </div>
                    <div>
                        <span >{currentDateFormat(currentDate)}</span>
                    </div>
                  </div>
                </section>
                <section>
                    <div className='bg-white  px-5 py-4'>
                    <Table striped bordered hover className='tbl-require'>
        <thead>
            <tr>
                <th style={{width:'5%'}}>#</th>
                <th style={{width:'20%'}}>Inspection Date</th>
                {/* <th style={{width:'20%'}}>Driver Name</th> */}
                <th style={{width:'20%'}}>Driver Name</th>
                <th style={{width:'35%'}}>Vehicle Condition</th>
                <th style={{textAlign:'center',width:'20%'}}>Action</th>
            </tr>
        </thead>
        <tbody>
          {console.log("checkListReport",checkListReport)}
            {checkListReport && checkListReport.map((item, index) => {
              let components = [];
              try {
                const parsedOnce = JSON.parse(item.component);
                        components = typeof parsedOnce === 'string'
                          ? JSON.parse(parsedOnce)
                          : parsedOnce;
                
              } catch (err) {
                console.error('Invalid component format:', err);
              }
               const failedComponents = components.filter(c => c.answer === '2' || c.answer === '3');
             return  ( <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{dateFormat(item.inspection_date)}</td>
                    {/* <td>{`${item.driverDetails.first_name} ${item.driverDetails.middle_name} ${item.driverDetails.last_name}`}</td> */}
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        
                         <a href={item.driverDetails?.user_role == 2  ? `/home/profile/myProfile` :`/home/driver/profile/id?profilId=${Base64.encode(item?.driverDetails?.user_id)}` } // Replace with the correct route
                            target="_blank" // Open in a new tab
                            onClick={() => localStorage.setItem('activeMenu', 'Driver List')} 
                            rel="noopener noreferrer" // Security best practice 
                            style={{ textDecoration: 'none', color: 'rgb(49, 135, 111)' }} // Inherit color and remove underline
                        >
                           {item.driverDetails?.first_name && item?.driverDetails?.last_name ? `${item.driverDetails?.first_name} ${item.driverDetails?.middle_name} ${item?.driverDetails?.last_name}` : item?.driverDetails?.full_name}
                        </a>
                     </div>
                    </td>
                   <td>
                      {failedComponents.length > 0 ? (
                        
                        <div style={{ textAlign: 'left' }}>
                          {failedComponents.map((c, idx) => (
                            <div key={idx} style={{ marginBottom: '4px' }}>
                            <span>
                              {(questionList[c.questionId-1]?.check_list) || `Question ${c.questionId}`} –{' '}
                            </span>
                            <span style={{ color: 'red',fontSize:'13px' }}>{c.answer === '2' ? 'Requires Attention' : 'Needs Repair'}</span>
                            {/* {idx < failedComponents.length - 1 && <span>,</span>} */}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>Good Condition</span>
                      )}
                    </td>
                    <td style={{textAlign:'center'}}>
                        <div onClick={() => generatePDF(item, index)}
                            style={{
                                     justifyContent: 'center',
                                    color: '#ffffff',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                 }} >
                            {loadingRow === index ? (
                              <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: '5px', color: '#dd0f0f', fontSize: '17px' }} className="fa-2x" />
                             ) : (
                              <><i class="pi pi-file-pdf" style={{ color: 'red', fontSize: '18px' }}></i></>
                             )}
                        </div>
                    </td>

                </tr>
)})}
        </tbody>
    </Table>
  
    {pdfDetails && (
              // <div style={{visibility: 'none'}} >
           <div style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'hidden', top: '-9999px', left: '-9999px' }}>  
              <VehiclePDF ref={pdfRef} details={pdfDetails} checkList={checkList}  />
            </div>
          )}
                        
                    </div>
                </section>
            </div>
            
        </div>
        
    );
    
}

export default VehicleReport